import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';


import { Account } from '../../../model/account';
import { Subscription } from 'rxjs';
import { UserManager } from '../../../services/managers/user.manager';

import { Organization } from '../../../model/organization';
import { NavParams } from 'ionic-angular';
import { AccountHelper } from '../../../lib/accountHelper';
import { Rodeo } from 'model/rodeo';

@Component({
    selector: 'main-photographer',
    templateUrl: 'photographer.html'
})
export class PhotographerMain {
    viewMode = 'upload';
    
    accountHelper = AccountHelper.instance();
    account: Account = new Account();

    loadingData: boolean = true;
    popoverActive: boolean;

    condensed: boolean;
    prompted: boolean;
    subscriptions: Subscription[] = [];    

    selectedRodeo: Rodeo;

    constructor(public nav: NavController, private userManager : UserManager) { }

    ionViewDidEnter() {
        this.subscriptions.push(this.userManager.account.subscribe(account => {
            this.account = account as Account;
        }));
    }

    ionViewWillLeave() {
        for(let i = 0; i < this.subscriptions.length; i++) {
            let subscription = this.subscriptions[i];

            if (!subscription.closed)
                subscription.unsubscribe();
        }
    }

    showUpload() {
        this.viewMode = 'upload';
    }

    showReport() {
        this.viewMode = 'report';
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/photographer/photographer.ts